import { render, staticRenderFns } from "./AddToBookmarks.vue?vue&type=template&id=651cf649&"
import script from "./AddToBookmarks.vue?vue&type=script&lang=js&"
export * from "./AddToBookmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports